import { Component } from '@angular/core';

@Component({
  selector: 'app-problemas-tecnicos',
  templateUrl: './problemas-tecnicos.component.html',
  styleUrl: './problemas-tecnicos.component.scss'
})
export class ProblemasTecnicosComponent {

}
